export enum NavigationModeType {
  StrafeMode = 'strafeMode',
  SingleHandedMode = 'singleHandedMode',
}

export const NAVIGATION_MODES = [
  {
    id: NavigationModeType.StrafeMode,
    labelKey: 'settingsModal.navigationModes.strafeMode',
  },
  {
    id: NavigationModeType.SingleHandedMode,
    labelKey: 'settingsModal.navigationModes.singleHandedMode',
  },
];
